import { useFormatMessage } from '@zennolab_platform/webui-sdk/dist/hooks';

import type { AnnouncementStatus } from '../../types/announcement';
import { StatusTag } from '../tags';
import { BackLink, Heading, IdNumber } from './styled';

/** Back link to the list and the page title with the status; the UA2 tab already names the section. */
export function FormHeader({ heading, id, status }: { heading: string; id?: string; status?: AnnouncementStatus }) {
  const { t } = useFormatMessage();
  return (
    <>
      <BackLink to="/announcements">
        ←{' '}
        {t({
          id: 'announcements.form.back',
          defaultMessage: 'К списку анонсов',
          description: 'Ссылка назад на странице формы',
        })}
      </BackLink>
      <Heading>
        {heading}
        {id !== undefined && <IdNumber>#{id}</IdNumber>}
        {status !== undefined && <StatusTag status={status} />}
      </Heading>
    </>
  );
}
